import { all, fork } from 'redux-saga/effects';
import speedtestSaga from './speedtests';

export default function* rootSaga() {
  yield all([
    fork(speedtestSaga),
  ]);
}
